// bar-visualizer.component.ts
import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AudioVisualizerService } from './audio-visualizer.service';

@Component({
  selector: 'app-bar-visualizer',
  templateUrl: './bar-visualizer.component.html',
  styleUrls: ['./bar-visualizer.component.scss']
})
export class BarVisualizerComponent implements OnInit, OnDestroy {
  @Input() mediaStreamTrack!: MediaStreamTrack;
  private audioContext!: AudioContext;
  private analyser!: AnalyserNode;
  private source!: MediaStreamAudioSourceNode;
  private dataArray!: Uint8Array;
  private animationId!: number;
  private frameCounter = 0;
  private updateFrequency = 8; // Update every 8 frames (~8fps instead of 60fps)

  barHeights: number[] = [10]; // Initial heights

  bars = Array.from({ length: 3 }, () => ({ visibleBars: 1 }));
  constructor(
    private elRef: ElementRef, private renderer: Renderer2
  ){}

  ngOnInit() {
    if (this.mediaStreamTrack) {
      const stream = new MediaStream([this.mediaStreamTrack]);
      this.audioContext = new AudioContext();
      this.source = this.audioContext.createMediaStreamSource(stream);
      this.analyser = this.audioContext.createAnalyser();
      this.analyser.fftSize = 128;
      this.source.connect(this.analyser);
      this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);
      this.animate();
    }
  }

  // animate = () => {
  //   this.analyser.getByteFrequencyData(this.dataArray);

  //   const mid = Math.floor(this.dataArray.length / 2);
  //   const firstHalfAvg = this.avg(this.dataArray.slice(0, mid));
  //   const secondHalfAvg = this.avg(this.dataArray.slice(mid));

  //   this.barHeights[0] = Math.max(10, (firstHalfAvg / 255) * 100);
  //   this.barHeights[1] = Math.max(10, (secondHalfAvg / 255) * 100);

  //   const volume = this.dataArray.reduce((a, b) => a + b, 0) / this.dataArray.length;
  //    // Convert volume (0-255) to speed (slower = lower volume)
  //    const speed = 0.2 + (volume / 255) * 1.2; // range: 0.2s to 1.4s
  //    this.renderer.setStyle(
  //      this.elRef.nativeElement.querySelector('.diagonal-bars'),
  //      'animationDuration',
  //      `${speed.toFixed(2)}s`
  //    );

  //   this.animationId = requestAnimationFrame(this.animate);
  // };

  animate = () => {
    this.analyser.getByteFrequencyData(this.dataArray);
    
    // Only update bars every few frames to reduce blinking
    this.frameCounter++;
    if (this.frameCounter >= this.updateFrequency) {
      this.frameCounter = 0;
      
      const volume = this.dataArray.reduce((a, b) => a + b, 0) / this.dataArray.length;
      const levels = this.volumeToLevels(volume);
      
      this.bars.forEach((bar, i) => {
        bar.visibleBars = levels[i] || 0;
      });
    }

    this.animationId = requestAnimationFrame(this.animate);
  };

  volumeToLevels(volume: number): number[] {
    let norm = volume / 255;

    // Much more sensitive - boost even small audio levels
    norm = Math.pow(norm, 0.15); // Lower exponent = more sensitive

    // Lower minimum threshold for more dynamic range
    norm = Math.max(0.1, norm);

    const maxLevel = 3;
    
    // Add subtle randomness for more natural animation
    const randomFactor = 0.8 + Math.random() * 0.2; // 0.9 to 1.1 (less variation)
    const adjustedNorm = Math.min(1, norm * randomFactor);
    
    const base = Math.ceil(adjustedNorm * maxLevel);
    
    // Create more stable patterns with occasional variation
    const shouldVary = Math.random() > 0.7; // Only vary 30% of the time
    const pattern1 = shouldVary ? Math.max(1, base - 1) : base;
    const pattern2 = base; // Center column stays stable
    const pattern3 = shouldVary ? Math.max(1, base - 1) : base;
    
    return [pattern1, pattern2, pattern3];
  }

  private avg(arr: Uint8Array): number {
    return arr.reduce((a, b) => a + b, 0) / arr.length;
  }

  ngOnDestroy(): void {
    cancelAnimationFrame(this.animationId);
    this.audioContext?.close();
  }
}
